(function () {
    document.addEventListener("DOMContentLoaded", function () {
        let conditionFeature = document.querySelectorAll(".condition-feature-card p.short-intro");
        if (conditionFeature.length > 0) {
            Array.prototype.forEach.call(conditionFeature, function (item, index) {
                $clamp(item, { clamp: 3, useNativeClamp: false });
            });
        }
        
        let cardShortDescription = document.querySelectorAll(".card p.short-intro");
        if (cardShortDescription.length > 0) {
            Array.prototype.forEach.call(cardShortDescription, function (item, index) {
                $clamp(item, { clamp: 3, useNativeClamp: false });
            });
        }
    });
})();